import { render, staticRenderFns } from "./Secondetails.vue?vue&type=template&id=2b4dc000&scoped=true&"
import script from "./Secondetails.vue?vue&type=script&lang=js&"
export * from "./Secondetails.vue?vue&type=script&lang=js&"
import style0 from "./Secondetails.vue?vue&type=style&index=0&id=2b4dc000&scoped=true&lang=css&"
import style1 from "./Secondetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4dc000",
  null
  
)

export default component.exports